const reserveList = () => import('@/views/main/reserve/list/list.vue')
export default {
  path: '/main/reserve/list',
  name: 'reserveList',
  component: reserveList,
  children: []
}
